import * as T from 'three';
import { C, mesh, ball, box, cyl, ring, link, tube, star, eyes, fur, scarf, boots, limbs, coat, belt, humanHead, gun, antler, candy } from './model-kit.js';

export const festive = {
  'present'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
limbs(r,'#d5b873',C.gold,'#684baf');
      box(body,'#7858bd',0,1.55,0,1.35,1.40,1.00);box(body,'#9b72e4',0,2.25,0,1.48,.22,1.10);
      box(body,C.gold,0,1.57,.53,.23,1.40,.08,.3);box(body,C.gold,0,1.48,.53,1.36,.21,.08,.3);
      for(const s of [-1,1]){const bow=ring(body,'#ffe298',s*.28,2.52,0,.30,.078,.4);bow.scale.set(1.08,.7,1);bow.rotation.z=-s*.43;}
      ball(body,C.gold,0,2.43,.05,.14);eyes(body,1.86,.57,.27,C.dark,true);
      box(body,'#fff3d5',.49,1.14,.61,.23,.34,.04).rotation.z=-.18;
      star(body,'#d65685',.49,1.15,.65,.074);
  },
  'candy-cane'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
limbs(r,'#de334f',C.white,'#9c254c');
      candy(body,[[0,.83,0],[0,1.7,0],[0,2.5,0],[.08,2.94,0],[.43,3.05,0],[.63,2.80,0],[.54,2.53,0]],.22);
      box(body,C.dark,0,2.32,.20,.54,.30,.11);eyes(body,2.35,.28,.14,'#ff5e7d',true);scarf(body,'#2b8e80',1.94);
      for(const [arm,s] of [[la,-1],[ra,1]])candy(arm,[[0,-.54,.1],[s*.06,-.8,.25],[s*.15,-1.05,.48],[s*.34,-.91,.55]],.10);
      for(const l of [ll,rl])for(let i=0;i<3;i++)cyl(l,C.red,0,-.1-i*.14,0,.178,.178,.055);
  },
  'gingerbread'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
limbs(r,'#bd733f','#b3703d','#e3a363');box(body,'#bd733f',0,1.5,0,1.1,1.2,.52);
      ball(head,'#cf8e4e',0,0,0,.57,.57,.24);ring(head,'#fff2d8',0,0,.22,.47,.039);eyes(head,.1,.24,.20,C.dark,true);
      tube(head,C.white,[[-.19,-.22,.25],[0,-.29,.27],[.19,-.22,.25]],.035);
      for(let i=0;i<3;i++)ball(body,[C.red,'#55b994',C.gold][i],0,1.82-i*.25,.3,.105,.105,.07,.1);
      for(const s of [-1,1])tube(body,C.white,[[s*.49,1.99,.3],[s*.48,1.85,.3],[s*.45,1.35,.3],[s*.32,.99,.3]],.035);
      for(const a of [la,ra]){ring(a,C.white,0,-.41,0,.19,.035).rotation.x=Math.PI/2;ball(a,C.red,0,-.67,.22,.16,.14,.06);}
      box(body,'#6b3930',0,.98,0,1.05,.1,.58);
  },
  'light-bulb'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
limbs(r,'#257465','#255c59',C.dark);
      for(const a of [la,ra])for(let i=0;i<5;i++)cyl(a,'#e18b8c',0,-.06-i*.1,0,.185,.185,.035);
      const profile=[[0,0],[.25,.07],[.38,.22],[.61,.63],[.6,.98],[.42,1.32],[.10,1.57],[0,1.66]].map(p=>new T.Vector2(...p));
      mesh(body,new T.LatheGeometry(profile,20),'#cf368c',0,1.1,0,1,1,1,.32,.32);
      for(let i=0;i<4;i++)cyl(body,'#829db1',0,1.14+i*.09,0,.30,.30,.055,16,.7);
      tube(body,'#ffbfee',[[-.25,1.65,.48],[-.1,1.85,.55],[.1,1.7,.55],[.26,2.05,.51]],.035);
      eyes(body,2.26,.54,.2,C.dark,true);ball(body,'#ffdef7',-.23,2.46,.41,.11,.24,.042,.2,.5);
      cyl(body,C.dark,0,.98,0,.24,.18,.23);
  },
  'yule-log'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
limbs(r,'#865b3e','#805136','#593d35');cyl(body,'#855537',0,1.60,0,.62,.7,1.7,12);
      cyl(body,'#d3a069',0,2.47,0,.61,.61,.08,16);for(let i=0;i<3;i++)ring(body,'#775033',0,2.514,0,.16+i*.14,.019).rotation.x=-Math.PI/2;
      for(let i=0;i<9;i++){const a=i/9*Math.PI*2;const plank=box(body,i%2?'#9a6942':'#6e482f',Math.cos(a)*.6,1.55,Math.sin(a)*.6,.20,1.49,.15);plank.rotation.y=-a;}
      eyes(body,1.95,.65,.23,'#ffba43',true);box(body,C.dark,0,1.63,.69,.42,.13,.03);
      for(let i=0;i<6;i++){const a=i*2.4,x=Math.cos(a)*.32,z=Math.sin(a)*.32;const flame=cyl(body,i%2?'#ffc66b':'#ff794c',x,2.64+(i%3)*.10,z,0,.18,.74+(i%2)*.3,6,0,.18);flame.rotation.z=x*.5;const core=cyl(body,'#ffca76',x,2.59+(i%3)*.10,z+.14,0,.060,.40,6,0,.42);core.rotation.z=x*.5;}
      for(const a of [la,ra])for(const s of [-1,1])link(a,'#50362e',[0,-.67,0],[s*.2,-.94,.06],.035);
      scarf(body,'#598453',2.22);
  },
  'snowman'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
ll.visible=rl.visible=false;ball(body,C.snow,0,.65,0,.78,.69,.70);ball(body,'#f4fcff',0,1.51,0,.62,.65,.58);ball(head,C.snow,0,0,0,.53,.51,.48);
      for(const s of [-1,1])ball(head,C.dark,s*.19,.13,.44,.075);const carrot=cyl(head,'#f39145',0,-.015,.60,0,.09,.48,8);carrot.rotation.x=Math.PI/2;
      for(let i=0;i<5;i++){const a=Math.PI+.25+i*.63;ball(head,C.dark,Math.cos(a)*.20,-.08+Math.sin(a)*.2,.445,.035);}
      for(let i=0;i<3;i++)ball(body,C.dark,0,1.69-i*.28,.57,.075);
      for(const [a,s] of [[la,-1],[ra,1]]){link(a,'#805b40',[0,0,0],[s*.21,-.38,.05],.045);link(a,'#805b40',[s*.21,-.38,.05],[s*.25,-.85,.10],.04);for(const n of [-1,0,1])link(a,'#805b40',[s*.25,-.70,.10],[s*.25+n*.13,-.97,.13],.025);}
      scarf(body,'#d75c70',2);cyl(head,C.dark,0,.48,0,.62,.62,.08,24).rotation.z=-.08;cyl(head,C.dark,-.035,.76,0,.35,.38,.54,16).rotation.z=-.08;cyl(head,'#4f9b83',-.02,.55,0,.38,.38,.14);
  },
  'evergreen'(r) {
    const {root,body,head,la,ra,ll,rl}=r;
limbs(r,'#7f6044','#765036','#9f7953');head.visible=false;
      for(let i=0;i<3;i++){
        const y=.92+i*.65,radius=1.03-i*.22;cyl(body,['#245e4e','#28775b','#379768'][i],0,y,0,.10,radius,1.05,10);
        const snow=cyl(body,'#c6eee2',0,y+.06,0,.06,radius*.86,.90,10);snow.scale.set(1,.23,1);snow.position.y=y-.20;
        for(let j=0;j<5;j++){const a=j/5*Math.PI*2+i*.8;ball(body,[C.red,C.gold,'#8dddff'][j%3],Math.cos(a)*radius*.66,y-.16,Math.sin(a)*radius*.66,.105,.12,.105,.45,.10);}
      }
      eyes(body,2.35,.31,.16,C.dark);star(body,C.gold,0,3.03,0,.31);
      for(const [a,s]of [[la,-1],[ra,1]]){a.position.y=1.58;link(a,'#806043',[0,0,0],[s*.24,-.47,0],.07);for(const k of [-1,1])link(a,'#806043',[s*.24,-.47,0],[s*.24+k*.12,-.67,.06],.035);}
  },
};
